import React, { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import AppRouter from './AppRouter';
import Header from './components/Header';
import Footer from './components/Footer';
import './css/main.css';
import { AuthProvider } from './security/AuthLogin';

function Layout() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login'; // Verificamos si la página es login

    // Al cambiar de ruta, sube el scroll al tope de la página
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="App">
      {/* Solo mostramos Header y Footer si no estamos en la página de login */}
      {!isLoginPage && <Header />}
      <AppRouter />
      {!isLoginPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider> {/* Mueve AuthProvider para envolver toda la aplicación */}
      <Router>
        <Layout />
      </Router>
    </AuthProvider>
  );
}

export default App;
